import { connect } from 'react-redux';
import { getScreenData, removeScreenData, setScreenData } from 'cw-ui-core';
import AlertNotification from 'src/asio-neon-components/AlertNotification/AlertNotification';
import { toArray } from '../../util/Util';

const mapStateToProps = (state, ownProps) => {
    const alertData = toArray(getScreenData(state.screen, ['activeAlertMessage'], ownProps.screenKey));

    return {
        alertData,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setAlertScreenMessage: value => {
            dispatch(removeScreenData(['activeAlertMessage'], ownProps.screenKey));
            dispatch(setScreenData(['activeAlertMessage'], value, ownProps.screenKey));
        },
        removeAlertScreenMessage: () => {
            dispatch(removeScreenData(['activeAlertMessage'], ownProps.screenKey));
        },
    };
};

const AlertNotificationContainer = connect(mapStateToProps, mapDispatchToProps)(AlertNotification);

export default AlertNotificationContainer;
